import clsx from "clsx";
import styles from "./ExistingMemberCard.module.css";

interface getStartedProps {
  cardWidth: number;
  cardHeight: number;
  imageSrc: string;
  cardText: string;
  secondaryText?: string;
  selected?: boolean;
}

export default function ExistingMemberCard({
  cardHeight,
  cardWidth,
  imageSrc,
  cardText,
  secondaryText,
  selected
}: getStartedProps) {
  const cardStyle = {
    width: cardWidth,
    height: cardHeight
  };

  const imageStyle = {
    marginBottom: "10px",
    height: "55%"
  };

  return (
    <>
      <div className="max-sm:hidden">
        <div
          className={selected ? clsx(styles.emCardLargeSelected, styles.emCard) : clsx(styles.emCardLarge, styles.emCard)}
          style={cardStyle}
        >
          <img
            src={imageSrc}
            style={imageStyle}
            alt={cardText}
            width={cardWidth * 0.6}
            height={cardHeight * 0.6}
          />
          {cardText}
          <p style={{fontSize: 12}}>{secondaryText}</p>
          {secondaryText && secondaryText.trim() !== "" && <br />}
        </div>
      </div>
      <div className="sm:hidden grid grid-rows-1">
        <div
          className={selected ? clsx(styles.emCardSmallSelected, styles.emCard) : clsx(styles.emCardSmall, styles.emCard)}
          style={cardStyle}
        >
          <div className="mr-5">
            <img
              src={imageSrc}
              style={imageStyle}
              alt={cardText}
              width={cardWidth * 0.4}
              height={cardHeight * 0.4}
            />
          </div>
          <div>
            <span>{cardText}</span>
            <p style={{fontSize: 12}}>{secondaryText}</p>
          </div>
        </div>
      </div>
    </>
  );
}